import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { JWTService } from 'src/app/core/services/jwt.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-feedback-dialog',
  templateUrl: './feedback-popup-dialog.html',
  styleUrls: ['./feedback-popup.component.scss'],
})
export class FeedbackPopupDialog implements OnInit {
  formDetails: any = {};
  errorMsg: string = '';
  body: any = '';
  formError: boolean = false;
  feedback: boolean = false;
  to: any;
  cc: any;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private auth: AuthService,
    private jwt: JWTService,
    protected _notificationSvc: NotificationService,
    private dialogRef: MatDialogRef<FeedbackPopupDialog>
  ) {}
  toName = environment.toName;
  feedBackSubject = environment.feedBackSubject;

  send(event: any) {
    const user: any = this.jwt.getDecodedToken() || {};
    event.preventDefault();

    const formData: FormData = new FormData();
    formData.append('fromName', user.userid);
    formData.append('body', this.formDetails.body);
    formData.append('subject', this.feedBackSubject);
    formData.append('toName', this.toName);
    this.auth.sendRequest(formData).subscribe((result: any) => {
      this.dialogRef.close();
      this._notificationSvc.error('Success', 'Feedback Send Successfully');
      (error: any) => {
        this.errorMsg = 'Sending failed, please try again !';
      };
    });
  }
  close() {
    this.dialogRef.close();
  }
  validateSubject() {
    if (!this.formDetails.subject) {
      this.formError = true;
    }
  }
  validateFrom() {
    if (!this.formDetails.from) {
      this.formError = true;
    }
  }

  ngOnInit(): void {
    this.auth.getMail().subscribe((result: any) => {
      this.to = result.To;
      this.cc = result.CC;
    });
  }
}
